// ============================================================================
// CANCUN100 — MisVentasB.js  (APP 2/20 · Mis ventas del agente idéntica al mockup aprobado: acordeón de vidrio, sin tabla)
// ----------------------------------------------------------------------------
// Referencia que manda: 30 App sistema/Prototipos/mis-ventas-y-mi-bolsa-2.0 (MOCKUP APROBADO).html · estilos en styles/glass.css.
// Cerrado: folio, estado con punto («3 de 3 confirmados»), cliente, «Viaja dd-mmm · servicios»; a la derecha total y «Tu comisión $X».
// Abierto: Pago del cliente · Servicios · píldoras (todo lo que hacía la fila de botones) + UN botón con el siguiente paso.
// ============================================================================
import React from 'react';
import { itemsDe, itemVivo, num } from './contabilidadV3';
import { esDepositoPrevioV2 } from './historial';
import { Dinero, Chev, Estado, AjustesFolio } from './MiBolsaB';
import { Ic, ICONO_ACCION } from './iconos'; // APP 2/24
import ControlFolioB from './ControlFolioB'; // APP 2/25: 4 botones (Documentos · Pagos · Cambios · Historia)

const F0 = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
const $t = (v) => `$${F0.format(Math.round(num(v)))}`;
const fechaCorta = (f) => { if (!f) return ''; try { const d = new Date(String(f).slice(0, 10) + 'T12:00:00'); return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' }).replace('.', ''); } catch { return String(f).slice(0, 10); } };
const fechaItem = (it) => String(it.hotel_checkin || it.fecha_actividad || it.fecha || it.vuelo_salida || '').slice(0, 10);
const ESTADO_ITEM = { confirmado: ['ok', 'Confirmado'], enviado: ['warn', 'Enviado'], pendiente: ['', 'Pendiente'], revisar: ['bad', 'Revisar'], cancelado: ['bad', 'Cancelado'], reemplazado: ['', 'Reemplazado'] };

export function KpisVentas({ semana, mes, lugar }) {
  const sub = (k) => `${k.n} reserva${k.n !== 1 ? 's' : ''} · comisión ${$t(k.comision)}`;
  return (
    <div className="gl-kpis">
      <div className="gl-kpi gl-glass"><div className="gl-lbl">Vendido esta semana</div><div className="gl-v"><Dinero v={semana.total} /></div><div className="gl-s">{sub(semana)}</div></div>
      <div className="gl-kpi gl-glass"><div className="gl-lbl">Vendido este mes</div><div className="gl-v"><Dinero v={mes.total} /></div><div className="gl-s">{sub(mes)}</div></div>
      {lugar && <div className="gl-kpi gl-glass"><div className="gl-lbl">Tu lugar</div><div className="gl-v gl-num">{lugar.pos ? `#${lugar.pos}` : '—'}</div><div className="gl-s">{lugar.de ? `de ${lugar.de} agentes esta semana` : 'Sin datos'}</div></div>}
    </div>
  );
}

// Estado del folio cerrado: cancelado · borrador · historial · «k de n confirmados».
export const estadoVenta = (s, items) => {
  if (s.cancelado) return ['bad', 'Cancelado'];
  if (s.estado === 'borrador') return ['', 'Borrador'];
  if (s.en_historial === true && s.reactivacion_estado !== 'aprobada') return ['', 'Pagado · versión 2.0'];
  const vivos = (items || []).filter(itemVivo); const n = vivos.length; const k = vivos.filter((it) => it.estado_reserva === 'confirmado').length;
  if (!n) return ['', 'Sin servicios'];
  if (s.op_estado === 'confirmada') return ['ok', `${n} de ${n} confirmados`];
  return [k === n ? 'ok' : k > 0 ? 'warn' : (vivos.some((it) => it.estado_reserva === 'enviado') ? 'warn' : ''), `${k} de ${n} confirmado${n !== 1 ? 's' : ''}`];
};

// s = fila de reporte_ventas · pagos = pagos_cliente del folio · links = [[etiqueta, fn]] · principal = [etiqueta, fn] | null · extra = nodo (correo)
// APP 2/21: punto de color por pago (verde cubierta · morado RP · amarillo pendiente/parcial · gris borrado/cancelado).
// cupon = fila de cupones_admin del folio (pagos_cliente_total, margen, prepagos_v3) o null.
export const puntoVenta = (s, cupon) => {
  if (s.estado === 'eliminado') return ['off', 'Borrado'];
  if (s.cancelado) return ['off', 'Cancelado'];
  if (s.estado !== 'enviado_pago') return ['', 'Reserva sin mandar a pago'];
  if (s.es_rp_por_fuera) return ['rp', 'RP 80 %'];
  if (!cupon) return ['', 'Venta'];
  // RU-1 (manual base 2.0): se LEE de cupones_admin. Cubierta = ya no hay comisión bloqueada; amarillo = la vista aún bloquea (prepagos + margen sin cubrir, con la tolerancia de la vista).
  const bloqueada = num(cupon.comision_bloqueada_cliente), pagos = num(cupon.pagos_cliente_total);
  if (num(cupon.comision_agente) > 0 && bloqueada < 1) return ['ok', 'Cubierta'];
  return ['warn', pagos > 0 ? 'Pago parcial' : 'Pendiente de pago'];
};
const IDIOMAS = [['es', 'Español'], ['en', 'English'], ['pt', 'Português']];
const LLAVE_PDF_IDIOMA = 'c100-pdf-idioma';
// APP 2/24 (punto 3): un botón «PDF del cliente» con menú Español · English · Português; el idioma del cliente va primero y se recuerda el último usado.
export function BotonPDFCliente({ idiomaCliente, onAbrir }) {
  const [abierto, setAbierto] = React.useState(false);
  let ultimo = ''; try { ultimo = localStorage.getItem(LLAVE_PDF_IDIOMA) || ''; } catch { ultimo = ''; }
  const orden = IDIOMAS.slice().sort((a, b) => (a[0] === idiomaCliente ? -1 : b[0] === idiomaCliente ? 1 : 0));
  const elegir = (idi) => { setAbierto(false); try { localStorage.setItem(LLAVE_PDF_IDIOMA, idi); } catch { /* sin storage */ } onAbrir(idi); };
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <button type="button" className="gl-lnk" aria-haspopup="menu" aria-expanded={abierto} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setAbierto((v) => !v); }}><Ic n="FileText" chico /> PDF del cliente <Ic n="ChevronDown" chico /></button>
      {abierto && (
        <div role="menu" className="gl-menu" onClick={(e) => e.stopPropagation()}>
          {orden.map(([k, l]) => <button key={k} type="button" role="menuitem" className="gl-menu__item" aria-current={ultimo === k ? 'true' : undefined} onClick={(e) => { e.preventDefault(); elegir(k); }}><Ic n="FileText" chico /> {l}{k === idiomaCliente ? ' · del cliente' : ''}</button>)}
        </div>
      )}
    </span>
  );
}

// links = [[etiqueta, fn, claveDeIcono]] · principal = [etiqueta, fn, claveDeIcono] · pdfCliente = { idiomaCliente, abrir(idioma) }
export const franjaVenta = (s, cupon) => { if (s.cancelado) return 'bad'; const [t] = puntoVenta(s, cupon); return t === 'ok' || t === 'warn' || t === 'rp' ? t : ''; }; // APP 2/25
// control = props para ControlFolioB (APP 2/25) o null · liga = folio padre (texto) si es venta ligada
export function FolioVenta({ s, cupon = null, pagos = [], ajustes = [], links = [], principal = null, extra = null, abierto = false, pdfCliente = null, control = null, liga = null }) {
  const items = itemsDe({ servicios_detalle: s.cupon_items ?? s.servicios_detalle }).filter(itemVivo);
  const [confTipo, confTexto] = estadoVenta(s, items);
  const [pTipo, pTexto] = puntoVenta(s, cupon);
  const estTipo = pTipo || confTipo; const estTexto = s.estado === 'enviado_pago' && !s.cancelado && items.length ? `${pTexto} · ${confTexto}` : pTexto;
  const total = num(s.total), deposito = num(s.deposito);
  const prepagos = s.es_top_tours ? 0 : items.filter((it) => it.es_prepago).reduce((t, it) => t + num(it.subtotal_neto), 0);
  const abonos = (pagos || []).filter((p) => !p.es_deposito_inicial).reduce((t, p) => t + num(p.monto), 0);
  const balance = Math.max(0, total - deposito - abonos);
  const previo = esDepositoPrevioV2(s, pagos);
  const viaja = s.fecha_cancun || s.fecha_reserva; const hoy = new Date().toISOString().slice(0, 10);
  const nombreIt = (it) => it.nombre || it.sku || 'Servicio sin nombre'; // APP 2/24 (punto 5)
  const nombres = items.map(nombreIt).join(', ');
  const click = (f) => (e) => { e.preventDefault(); e.stopPropagation(); f(); };
  return (
    <details className="gl-f gl-glass" open={abierto || undefined} data-franja={franjaVenta(s, cupon) || undefined} style={{ opacity: s.cancelado ? .7 : 1 }}>
      <summary>
        <div style={{ minWidth: 0 }}>
          <span className="gl-folio">{s.folio}</span><Estado tipo={estTipo}>{estTexto}</Estado>{liga && <span className="gl-liga"><Ic n="Link" chico /> Ligado a {liga}</span>}
          {s.excluir_metricas && <Estado>Fuera de métricas</Estado>}
          <div className="gl-cli">{s.cliente || s.nombre || '—'}</div>
          <div className="gl-meta" title={nombres}>{viaja ? `${String(viaja).slice(0, 10) < hoy ? 'Viajó' : 'Viaja'} ${fechaCorta(viaja)}` : ''}{nombres ? ` · ${nombres}` : ''}{s.en_historial === true && s.reactivacion_estado !== 'aprobada' ? <span className="gl-nota"> · versión anterior</span> : null}</div>
        </div>
        <div className="gl-right">
          <div className="gl-v"><Dinero v={total} /></div><div className="gl-l">Tu comisión {$t(s.comision)}</div>
          <Chev />
        </div>
      </summary>
      <div className="gl-inner">
        <div className="gl-cols">
          <div className="gl-blk"><div className="gl-lbl">Pago del cliente</div>
            <div className="gl-kv">
              <span>Total de la venta</span><span>{$t(total)}</span>
              <span>Depósito</span><span>{$t(deposito)}</span>
              {prepagos > 0 && <><span>Prepagos</span><span>{$t(prepagos)}</span></>}
              {abonos > 0 && <><span>Abonos</span><span>{$t(abonos)}</span></>}
              <span className="gl-tot">Balance</span><span className="gl-tot">{$t(balance)}</span>
            </div>
            {previo && <div className="gl-nota">Depósito registrado antes de la versión 2.0.</div>}
          </div>
          <div className="gl-blk"><div className="gl-lbl">Servicios</div>
            {items.length === 0 ? <div className="gl-nota">Sin servicios.</div> : (
              <div className="gl-items">
                {items.map((it, i) => { const [t, l] = ESTADO_ITEM[it.estado_reserva] || ESTADO_ITEM.pendiente; return <div key={it.item_id || i} className="gl-it"><span>{fechaItem(it) ? fechaCorta(fechaItem(it)) + ' · ' : ''}{nombreIt(it)}</span><Estado tipo={t} m0>{l}</Estado></div>; })}
              </div>
            )}
          </div>
        </div>
        <AjustesFolio ajustes={ajustes} />
        {control && <ControlFolioB {...control} pdfCliente={pdfCliente && <BotonPDFCliente idiomaCliente={pdfCliente.idiomaCliente} onAbrir={pdfCliente.abrir} />} />}
        <div className="gl-acts">
          <div className="gl-links">{pdfCliente && !control && <BotonPDFCliente idiomaCliente={pdfCliente.idiomaCliente} onAbrir={pdfCliente.abrir} />}{links.map(([l, f, ic]) => <button key={l} type="button" className="gl-lnk" onClick={click(f)}>{ic && <Ic n={ICONO_ACCION[ic] || ic} chico />} {l}</button>)}{extra}</div>
          {principal && <button type="button" className="gl-btn" onClick={click(principal[1])}>{principal[2] && <Ic n={ICONO_ACCION[principal[2]] || principal[2]} />} {principal[0]}</button>}
        </div>
      </div>
    </details>
  );
}
